import { Group, Vector3 } from 'three/webgpu'

export default class DomTracked extends Group {
	static defaults = {
		element: null,
		camera: null,
		depth: 0,
		hideSource: true,
		cull: true,
	}

	constructor(options = {}) {
		super()

		this.options = { ...DomTracked.defaults, ...this.constructor.defaults, ...options }
		this.element = this.options.element
		this.camera = this.options.camera
		this.depth = this.options.depth

		this.ray = new Vector3()
		this.left = new Vector3()
		this.right = new Vector3()
		this.worldPerPixel = 0

		if (this.options.hideSource) this.element.style.visibility = 'hidden'
	}

	#project(ndcX, ndcY, target) {
		this.ray.set(ndcX, ndcY, 0.5).unproject(this.camera).sub(this.camera.position).normalize()

		const distance = (this.depth - this.camera.position.z) / this.ray.z

		return target.copy(this.camera.position).addScaledVector(this.ray, distance)
	}

	update() {
		const rect = this.element.getBoundingClientRect()

		if (rect.width === 0 || rect.height === 0) {
			this.visible = false
			return
		}

		if (this.options.cull) {
			this.visible = rect.bottom > 0 && rect.top < window.innerHeight

			if (!this.visible) return
		}

		const ndcY = -((rect.top + rect.height / 2) / window.innerHeight) * 2 + 1

		this.#project((rect.left / window.innerWidth) * 2 - 1, ndcY, this.left)
		this.#project((rect.right / window.innerWidth) * 2 - 1, ndcY, this.right)

		this.worldPerPixel = this.left.distanceTo(this.right) / rect.width

		this.position.copy(this.left).lerp(this.right, 0.5)
		this.quaternion.copy(this.camera.quaternion)

		this.layout(rect)
	}

	layout() {}

	dispose() {
		this.element.style.visibility = ''
	}
}
